export default __webpack_public_path__ + "static/media/menu-ellipsis_darkGray2.b1e3f6a9.svg";